<div class="slider-container" [ngClass]="{ realtime: realtime, live: isLive }" [style.width.%]="100"
    (click)="onTrackClick($event)" (touchstart)="onTrackClick($event)" #slider>
    <div class="slider-track"></div>
    <div class="slider-buffer" [style.width.%]="bufferPercentage"></div>
    <div class="slider-fill" [style.width.%]="playedPercentage"></div>
    <div class="slider-thumb" [style.left.%]="playedPercentage" (mousedown)="startDrag($event)"
        (touchstart)="startDrag($event)"></div>
</div>

<div class="tick-container" *ngIf="showTicks" #tickContainer>
    <div class="tick-timeline">
        <ng-container *ngFor="let tick of ticks; let index = index">
            <div *ngIf="!realtime || index < ticks.length - 1" class="tick-marker"
                [style.left]="tick.position - 1 + 'px'">
            </div>

            <div *ngIf="!realtime || index < ticks.length - 1" class="tick-label"
                [style.left]="tick.labelPosition + 'px'">
                {{tick.label}}
            </div>
        </ng-container>
    </div>
</div>